import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";
import { GET_PUBLIC_SPOT, globalConstants } from "../constants";

//Get all public spots list
const getAllPublicSpots = (params) => {
  return postRequest(
    `/${globalConstants.VERSION}/${GET_PUBLIC_SPOT}`,
    params,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get all paginated public and private spots list
const getPaginatedSpots = (data) => {
  return postRequest(`/${globalConstants.VERSION}/Spot/all`, data, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get public/private spots by id
const getSpotById = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Spot/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Update public spots by id
const updatePublicSpot = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/Spot/public/update`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//create public spots by id
const addPublicSpot = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/Spot/public/create`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Delete center public spot
const deletePublicSpot = (id) => {
  return deleteRequest(
    `/${globalConstants.VERSION}/Spot/public/centerSpot/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Delete center private spot
const deletePrivateSpot = (id) => {
  return deleteRequest(
    `/${globalConstants.VERSION}/Spot/private/centerSpot/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getAllSpots = (param) => {
  return postRequest(
    `/${globalConstants.VERSION}/Spot/all/view`,
    param,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getAllApprovedSpots = () => {
  return getRequest(`/${globalConstants.VERSION}/Spot/approved`, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
//Get spot by center id
const getSpotByCenterId = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Spot/centerSpots/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Update public spots status
const updatePublicSpotStatus = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/Spot/public/status`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const spotService = {
  getAllPublicSpots,
  getPaginatedSpots,
  updatePublicSpot,
  getSpotById,
  addPublicSpot,
  deletePublicSpot,
  deletePrivateSpot,
  getAllSpots,
  getSpotByCenterId,
  getAllApprovedSpots,
  updatePublicSpotStatus,
};
